var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.elements)?_c('div',{staticClass:"radio-button-group"},_vm._l((_vm.elements),function(element,index){return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vModel),expression:"vModel"}],key:index,staticClass:"radio-button-group-item",class:{
      stars: element.value === _vm.maximumValue && _vm.presentationMode,
      'checked-btn': _vm.checked === index,
    },style:({
      '--active-bg': _vm.profileColor,
      '--active-shadow': ("0 0 4px " + _vm.profileColor + "40, 0 0 8px " + _vm.profileColor + "69"),
    }),attrs:{"type":"radio","name":"definedTips","label":element.value.toLocaleString(_vm.$localeString, {
        style: 'currency',
        currency: _vm.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      })},domProps:{"value":_vm.tipsFormatter(element.value),"checked":_vm._q(_vm.vModel,_vm.tipsFormatter(element.value))},on:{"change":[function($event){_vm.vModel=_vm.tipsFormatter(element.value)},function($event){_vm.change(_vm.tipsFormatter(element.value), index)}]}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }